import { createContext } from "react";

export interface ContentActionsContext {
    onViewKnowledge: () => void;
}

const ContentActionsContext = createContext<null|ContentActionsContext>(null);

export default ContentActionsContext;